import {createModel} from '@@/package/utils/ModelUtil';
import Model from '@@/package/mapper/Model';
import type UserV2Response from "~~/package/apis/user/response/UserV2Response";
import {UserV2Type} from "~~/package/mapper/user/model/UserType";
import {ProviderType} from "~~/package/mapper/user/model/ProviderType";
import {MemberMenuAccessRole} from '~~/package/mapper/organization/model/OrganizationMemeberTypes';

export class UserV2Model extends Model {
    constructor(
        public uuid: string = "",
        public location: string = "",
        public fullName: string = "",
        public profileImageUrl: string = "",
        public points: UserPoints = new UserPoints(),
        public orgInfo: OrgInfo = new OrgInfo(),
        public locale: string = "en",
        public provider: ProviderType = ProviderType.LOCAL,
        public isMarketingConsent: boolean = false,

        public id: number = 0,
        public email: string = "",
        public emailAuthFlag: boolean = false,
        public nickName: string = "",
        public timeZone: string = "",

        public hasPassword: boolean = false,
        public credit: number = 0,

        public accessRoles: MemberMenuAccessRole[] = [],
        public pendingInvitation: boolean = false
) {
        super();
    }

    public static create(model: Partial<UserV2Response>): UserV2Model {
        return createModel<UserV2Model>(UserV2Model, {
            ...model,
            isMarketingConsent: model.marketingConsentFlag ?? false
        });
    }
}

class UserPoints extends Model {
    constructor(
        public today: number = 0,
        public total: number = 0,
        public ranking: number = 0
    ) {
        super();
    }
}

class OrgInfo extends Model {
    constructor(
      public orgName: string | null = null,
      public grades: string[] = [UserV2Type.ORG_MEMBER],
      public gradesName: string[] = [],
      public accessRoles: MemberMenuAccessRole[] = [],
      public hasOtherMembersFlag: boolean = false
    ) {
        super();
    }
}
